import React from 'react';
import warningSign from '../../assets/images/warning_sign.svg';

interface ErrorPageProps {
  error: string;
}

const TEMPLATE_MISSING_TEXT =
  'Template does not exist. Please save your template before continuing.';
const TEMPLATE_CARD_TITLE = 'Template doesn’t exist';
const TEMPLATE_CARD_BODY = 'Please add a template before continuing.';

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const normalized = (error || '').trim();
  const isTemplateMissing = normalized === TEMPLATE_MISSING_TEXT;

  if (isTemplateMissing) {
    return (
      <div className="flex items-center justify-center w-full bg-neutral-95 p-[10px] -mt-[3px] -ml-[10px] -mr-[10px] min-h-[80vh]">
        <div className="flex flex-col items-center gap-3 bg-white -mt-[50px] error-template-card">
          <img
            src={warningSign}
            width={72}
            height={61.032}
            alt="Warning"
            className="error-template-image"
          />
          <div className="error-template-title">{TEMPLATE_CARD_TITLE}</div>
          <div className="error-template-body">{TEMPLATE_CARD_BODY}</div>
        </div>
      </div>
    );
  }

  // Fallback generic error
  const fallback = normalized || 'An Error has occurred. Please try again later.';
  return (
    <div className="flex items-center justify-center h-full bg-gray-100 min-h-96">
      <div className="bg-white p-8 rounded shadow">
        <h1 className="text-2xl font-bold mb-4">Error</h1>
        <p className="text-red-500">{fallback}</p>
      </div>
    </div>
  );
};

export default ErrorPage;
